var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.toggleClick}},[_c('svg-icon',{staticClass:"wscn-icon hamburger",class:{'is-active':_vm.isActive},attrs:{"icon-class":"icon-arrow-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }